/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Input, FormFeedback, Tooltip } from "reactstrap";

const FileUploadInput = ({
  label = "Upload File",
  id = "fileUploadInput",
  name = "file",
  required = false,
  acceptedTypes = [],
  maxSize = Infinity,
  customErrorMessages = {
    required: "This field is required.",
    type: "Only the allowed file types are accepted.",
    size: `File size must be less than ${maxSize / (1024 * 1024)}MB.`,
  },
  showHelp = false,
  helpText = "Please upload a valid file.",
  onFileUpload = () => {},
  layout = "below", // Default layout (inline or below)
}) => {
  const [error, setError] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const validateInput = (files) => {
    setError(""); // Reset error message
    if (required && files.length === 0) {
      return customErrorMessages.required || "This field is required.";
    }

    // Convert FileList to an array for easier manipulation
    const filesArray = Array.from(files);

    for (let file of filesArray) {
      // Check for accepted file types
      if (acceptedTypes.length > 0 && !acceptedTypes.includes(file.type)) {
        return customErrorMessages.type || `Only allowed file types are: ${acceptedTypes.join(", ")}`;
      }
      // Check file size
      if (file.size > maxSize) {
        return customErrorMessages.size || `File size must be less than ${maxSize / (1024 * 1024)}MB.`;
      }
    }
    return ""; // No errors
  };

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;

    // Validate input and capture any error messages
    const errorMessage = validateInput(selectedFiles);
    if (errorMessage) {
      setError(errorMessage);
      return; // If there's an error, do not proceed
    }

    // If validation passes, call the onFileUpload handler
    if (onFileUpload) {
      onFileUpload(selectedFiles); // Pass the file array to the parent component
    }
  };

  return (
    <div className={layout === "inline" ? "d-flex align-items-center mb-2" : "mb-2"}>
      <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "20%" : "100%" }}>
        {label} {required && <span className="text-danger">*</span>}
        {showHelp && (
          <span id="helpTooltip" className="px-2">
            <i className="ri-question-line" style={{ cursor: 'pointer', fontSize: '16px' }}></i>
          </span>
        )}
      </label>
      {showHelp && (
        <Tooltip
          placement="right"
          isOpen={tooltipOpen}
          target="helpTooltip"
          toggle={() => setTooltipOpen(!tooltipOpen)}
        >
          {helpText}
        </Tooltip>
      )}
      <div className="w-100">
        <Input
          type="file"
          id={id}
          name={name}
          onChange={handleFileChange}
          className="form-control"
          multiple
        />
        {error && <FormFeedback type="invalid">{error}</FormFeedback>}
      </div>
    </div>
  );
};

export default FileUploadInput;
